export default __webpack_public_path__ + "static/media/section2a-card2img.46bb8176.svg";